'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pricingLevelFeature = require('./pricing-level-feature');

var _pricingLevelFeature2 = _interopRequireDefault(_pricingLevelFeature);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _contactUsButton = require('./contact-us-button');

var _contactUsButton2 = _interopRequireDefault(_contactUsButton);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CorporatePricingLevel = _react2['default'].createClass({
    displayName: 'CorporatePricingLevel',


    getInitialState: function getInitialState() {
        return { expanded: false };
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'corpLevelName': 'Enterprise'
        };
    },

    onLevelClick: function onLevelClick() {
        this.setState({ expanded: !this.state.expanded });
    },

    render: function render() {
        var bodyClasses = (0, _classnames2['default'])({
            'm-pricing-level--body': true,
            'small-12': true,
            'columns': true,
            'expanded': this.state.expanded
        });
        var seatBadge = '';
        if (!this.props.isApi) {
            seatBadge = _jsx('div', {
                className: 'm-pricing-level--seat-range hide-for-medium-down'
            }, void 0, _jsx('p', {
                className: 'max-seats-badge'
            }, void 0, '10+ users'));
        }
        var levelClasses = (0, _classnames2['default'])({
            'small-6': true,
            'medium-4': true,
            'medium-offset-1': true,
            'large-12': true,
            'large-offset-0': true,
            'columns': true,
            'level-title': true
        });
        var arrowContainerClasses = (0, _classnames2['default'])({
            'arrow-container': true,
            'hide-for-large-up': true,
            'hide-for-small': true,
            'small-2': true,
            'medium-1': true,
            'columns': true
        });
        var arrowClasses = (0, _classnames2['default'])({
            'l-vertical-align': true,
            'arrow': true,
            'expanded': this.state.expanded
        });
        var contactUsClasses = (0, _classnames2['default'])({
            'phone-container': true,
            'hide-for-large-up': true,
            'small-6': true,
            'medium-5': true,
            'medium-offset-1': true,
            'columns': true,
            'level-price': true
        });
        var phoneIconSrc = require('./pricing-icon-phone@2x.png');
        var lookingForMoreClasses = (0, _classnames2['default'])({
            'm-pricing-level--body': true,
            'small-10': true,
            'small-centered': true,
            'columns': true,
            'looking-for-more': true,
            'l-padding-t-50': this.props.coupon && this.props.coupon !== null
        });

        var mainFeature = '';
        var noFeatures = true;
        if (this.props.corporateFeatures && this.props.corporateFeatures.main_feature) {
            var name = this.props.corporateFeatures.main_feature.name ? this.props.corporateFeatures.main_feature.name : name;
            var detail = this.props.corporateFeatures.main_feature.detail ? this.props.corporateFeatures.main_feature.detail : null;
            var number = this.props.corporateFeatures.main_feature.number ? this.props.corporateFeatures.main_feature.number : null;
            mainFeature = _jsx(_pricingLevelFeature2['default'], {
                name: name,
                planName: this.props.name,
                detail: detail,
                number: number,
                expanded: this.state.expanded
            }, 'main-feature');
            noFeatures = false;
        }

        var features = '';
        if (this.props.corporateFeatures && this.props.corporateFeatures.features) {
            features = this.props.corporateFeatures.features.map(function (feature, i) {
                var name = feature.name ? feature.name : name;
                var detail = feature.detail ? feature.detail : null;
                var number = feature.number ? feature.number : null;
                return _jsx(_pricingLevelFeature2['default'], {
                    name: name,
                    planName: this.props.name,
                    detail: detail,
                    number: number,
                    expanded: this.state.expanded
                }, 'feature' + i);
            }.bind(this));
        }

        var phoneNumberClasses = (0, _classnames2['default'])({
            'contact-us-phone-number': true,
            'l-nowrap': true,
            'no-features-padding': noFeatures
        });
        var corpLevelColumnClasses = (0, _classnames2['default'])({
            'm-pricing-level': true,
            'small-12': true,
            'medium-12': true,
            'large-3': this.props.totalColumns >= 3,
            'large-4': this.props.totalColumns == 2,
            'large-6': this.props.totalColumns == 1,
            'columns': true,
            'end': true
        });
        return _jsx('div', {
            className: corpLevelColumnClasses
        }, void 0, _jsx('div', {
            className: 'm-pricing-level--header small-12 columns block',
            onClick: this.onLevelClick
        }, void 0, _jsx('div', {
            className: levelClasses
        }, void 0, _jsx('div', {
            className: 'level-title l-vertical-align-wrapper'
        }, void 0, _jsx('div', {
            className: 'l-vertical-align'
        }, void 0, this.props.corpLevelName.toUpperCase()))), _jsx('div', {
            className: contactUsClasses
        }, void 0, _jsx('div', {
            className: 'phone-container l-vertical-align-wrapper'
        }, void 0, _jsx('div', {
            className: 'l-vertical-align l-text-centered'
        }, void 0, _jsx('img', {
            src: phoneIconSrc,
            className: 'phone-icon'
        }), _jsx('div', {
            className: phoneNumberClasses
        }, void 0, _hfReactHelper2['default'].HfConstants.supportPhoneNumber)))), _jsx('div', {
            className: arrowContainerClasses
        }, void 0, _jsx('div', {
            className: 'level-title l-vertical-align-wrapper'
        }, void 0, _jsx('div', {
            className: arrowClasses
        }, void 0, ' ')))), _jsx('div', {
            className: bodyClasses
        }, void 0, _jsx('div', {
            className: 'first-section block'
        }, void 0, _jsx('div', {
            className: lookingForMoreClasses
        }, void 0, 'Looking for more?'), _jsx('div', {
            className: 'block'
        }, void 0, _jsx(_contactUsButton2['default'], {
            timePeriod: this.state.timePeriod,
            pricingSource: this.props.pricingSource
        })), _jsx('div', {
            className: phoneNumberClasses
        }, void 0, _jsx('img', {
            src: phoneIconSrc,
            className: 'phone-icon'
        }), ' ', _hfReactHelper2['default'].HfConstants.supportPhoneNumber), mainFeature)), features);
    }
});

module.exports = CorporatePricingLevel;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/corporate-pricing-level.jsx
 ** module id = 787
 ** module chunks = 0
 **/